import dayjs from '@srm/ui/lib/dayjs';
import { plural } from '@srm/ui/lib/pluralize';

export type DeliveryTone = 'today' | 'soon' | 'later';

export interface IDeliveryLabel {
    /** Основной текст чипа: «сегодня, 18:00» / «завтра, 09:00» / «22 июл, 10:00». */
    label: string;
    /** Вторичная подпись: «через 12 дней» (только для дальних сроков). */
    sub?: string;
    /** Близость срока — красит точку-индикатор чипа. */
    tone: DeliveryTone;
}

/**
 * Человекочитаемое время доставки напоминания с кодированием близости срока.
 * `now` инжектится для детерминированных тестов.
 */
export const formatDelivery = (value: Date | string, now: Date = new Date()): IDeliveryLabel => {
    const date = dayjs(value);
    const daysAhead = date.startOf('day').diff(dayjs(now).startOf('day'), 'day');
    const time = date.format('HH:mm');

    if (daysAhead <= 0) {
        // Сегодня (и защитно — просроченные, которые бэк ещё не убрал).
        return { label: `сегодня, ${time}`, tone: 'today' };
    }
    if (daysAhead === 1) {
        return { label: `завтра, ${time}`, tone: 'soon' };
    }
    return {
        label: `${date.format('D MMM').replace('.', '')}, ${time}`,
        sub: `через ${daysAhead} ${plural(daysAhead, ['день', 'дня', 'дней'])}`,
        tone: 'later',
    };
};

/** «создано сегодня, 11:42» / «создано вчера, 16:05» / «создано 03.07.2026». */
export const formatCreated = (value: Date | string, now: Date = new Date()): string => {
    const date = dayjs(value);
    const daysAgo = dayjs(now).startOf('day').diff(date.startOf('day'), 'day');

    if (daysAgo === 0) return `создано сегодня, ${date.format('HH:mm')}`;
    if (daysAgo === 1) return `создано вчера, ${date.format('HH:mm')}`;
    return `создано ${date.format('DD.MM.YYYY')}`;
};
